import * as React from "react";

import { Section } from "../ui/atoms/section";
import { FilterByDateRange } from "../ui/organisms/filter-by-date-range";
import { SelectionMode } from "@fluentui/react";
import { ListZoneEvents } from "../ui/molecules/list-zone-events";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";

export class PageZoningActivity extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout breadcrumb={store.i18n.t("page.zoningActivity.title")} classic>
                <Section fill>
                    <ListZoneEvents
                        commandBar={<FilterByDateRange onDateRangeChanged={() => {}} />}
                        selectionMode={SelectionMode.none}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
